import { render, staticRenderFns } from "./ToEditProductModal.vue?vue&type=template&id=b338d974&scoped=true&"
import script from "./ToEditProductModal.vue?vue&type=script&lang=js&"
export * from "./ToEditProductModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b338d974",
  null
  
)

export default component.exports